import { render, staticRenderFns } from "./ContasReceberDadosValorReceber.vue?vue&type=template&id=45470afa&scoped=true&"
import script from "./ContasReceberDadosValorReceber.vue?vue&type=script&lang=js&"
export * from "./ContasReceberDadosValorReceber.vue?vue&type=script&lang=js&"
import style0 from "./ContasReceberDadosValorReceber.vue?vue&type=style&index=0&id=45470afa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45470afa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
